import React, { Component } from 'react';
import * as $ from 'jquery';
import moment from 'moment-timezone';
import { Trans, translate } from 'react-i18next';


class DomicilioSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        $('#date').datepicker({
            onSelect: (d, i) => {
                if (d !== i.lastVal) {
                    this.props.handleDateChange(d);
                }
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="jumbotron panel-search-resvations">
                <div className="row">
                    <div className="col-md-12">
                        <form method="post" onSubmit={this.props.handleRoomSearch}>
                            <fieldset>
                                <div className="form-group">
                                    <label htmlFor="center">
                                        {t('guest.benefits.city')}
                                    </label>
                                    <select
                                        className="form-control"
                                        id="city-select"
                                        onChange={this.props.handleCityChange}
                                        value={this.props.city}>
                                        {this.props.cuidad.map((city, index) =>
                                            index <= 0 ? (
                                                <option key={index} className="opcion-select" value={index}>
                                                    {t('guest.survey.holder_city')}
                                                </option>
                                            ) : (
                                                <option key={index} className="opcion-select" value={city.id}>{city.name}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <button
                                        className="btn btn-primary btn-full-width"
                                        type="submit">
                                        {t('dashboard.reservations.btn_search')}
                                    </button>
                                    <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                                        <div className="progress-bar">
                                            <div className="progress-bar-value"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className={this.props.error ? "" : "hidden"}>
                                    <div className="form-group">
                                        <div className="alert alert-warning">
                                            {this.props.error}
                                            <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}


export default translate('common')(DomicilioSearch);


// WEBPACK FOOTER //
// ./src/store/Domicilio/DomicilioSearch.js